<!--
 * @Author: daidai
 * @Date: 2022-03-01 14:13:04
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-09-27 15:04:49
 * @FilePath: \web-pc\src\pages\big-screen\view\indexs\right-top.vue
-->
<template>
  <Echart
    id="rightTop"
    :options="option"
    class="right_top_inner"
    v-if="pageflag"
    ref="charts"
  />
  <Reacquire v-else @onclick="getData" style="line-height: 200px">
    重新获取
  </Reacquire>
</template>

<script>
import { currentGET } from "api/modules";
import {color, graphic} from "echarts"
import { statCurDateEquTempPeriodOfTimeData } from 'api/modules/largescreen'
export default {
  data() {
    return {
      option: {},
      pageflag: false,
      timer: null,
    };
  },
  created() {
   
  },

  mounted() {
     this.getData();
  },
  beforeDestroy() {
    this.clearData();
  },
  methods: {
    clearData() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    getData() {
      this.pageflag = true;
      // this.pageflag =false
      // currentGET("big4").then((res) => {
      //   if (!this.timer) {
      //     console.log("报警次数", res);
      //   }
      //   if (res.success) {
      //     this.countUserNumData = res.data;
      //     this.$nextTick(() => {
      //       this.init(xAxisData, res.data.numList, res.data.numList2),
      //         this.switper();
      //     });
      //   } else {
      //     this.pageflag = false;
      //     this.$Message({
      //       text: res.msg,
      //       type: "warning",
      //     });
      //   }
      // });

      statCurDateEquTempPeriodOfTimeData().then((res) => {
        if (!this.timer) {
          console.log("设备温度记录", res);
        }
        if (res.code == 200) {

          let resData = res.data;
          let xAxisData = resData.allHourMinutes;

          let legendData = [];
          if(resData.nameMap){
            Object.entries(resData.nameMap).forEach(([key, value]) => {
                legendData.push(value);
            });
          }
          let color1 = ["rgba(238, 114, 5, .7)", "rgba(110, 238, 5, .7)", "rgba(5, 110, 238, .7)", "rgba(195, 5, 238, .7)", "rgba(238, 5, 44, .7)", "rba(184, 5, 238, .7)"];
          let color2 = ["rgba(238, 114, 5, .0)", "rgba(110, 238, 5, .0)", "rgba(5, 110, 238, .0)", "rgba(195, 5, 238, .0)", "rgba(238, 5, 44, .0)", "rba(184, 5, 238, .0)"];

          let seriesData = [];
          if(resData.dataValueMap){
            let i = 0;
            Object.entries(resData.dataValueMap).forEach(([key, value]) => {
                value.color1 = color1[i];
                value.color2= color2[i];
                seriesData.push(value);
                i++;
            });
          }
          
          this.$nextTick(() => {
            this.init(xAxisData, legendData, seriesData),
              this.switper();
          });
        } else {
          this.pageflag = false;
          this.$Message({
            text: res.msg,
            type: "warning",
          });
        }
      });
    },
    //轮询
    switper() {
      if (this.timer) {
        return;
      }
      let looper = (a) => {
        this.getData();
      };
      this.timer = setInterval(
        looper,
        this.$store.state.setting.echartsAutoTime
      );
      let myChart = this.$refs.charts.chart;
      myChart.on("mouseover", (params) => {
        this.clearData();
      });
      myChart.on("mouseout", (params) => {
        this.timer = setInterval(
          looper,
          this.$store.state.setting.echartsAutoTime
        );
      });
    },
    init(xAxisData, legendData, seriesData) {
      this.option = {
        xAxis: {
          type: "category",
          data: xAxisData,
          boundaryGap: false, // 不留白，从原点开始
          splitLine: {
            show: false,
            lineStyle: {
              color: "rgba(31,99,163,.2)",
            },
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "rgba(31,99,163,.1)",
            },
          },
          axisLabel: {
            color: "#7EB7FD",
            fontWeight: "500",
            rotate: 65, // 旋转65度
          },
        },
        yAxis: {
          type: "value",
          minInterval: 2,
          maxInterval: 2,
          splitLine: {
            show: false,
            lineStyle: {
              color: "rgba(31,99,163,.2)",
            },
          },
          axisLine: {
            lineStyle: {
              color: "rgba(31,99,163,.1)",
            },
          },
          axisLabel: {
            color: "#7EB7FD",
            fontWeight: "500",
          },
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(0,0,0,.6)",
          borderColor: "rgba(147, 235, 248, .8)",
          textStyle: {
            color: "#FFF",
          },
        },
        legend: {
            top:'0%',
            left:'0%',
            data: legendData,
            textStyle: {
                color: 'rgba(255,255,255,.5)', // 上面字体颜色
                fontSize:'20',
            }
        },
        grid: {
          //布局
          show: true,
          left: "10px",
          right: "30px",
          bottom: "10px",
          top: "28px",
          containLabel: true,
          borderColor: "#1F63A3", // 边框颜色
        },
        series: seriesData.map(item => ({
            data: item.data,
            type: "line",
            smooth: true,
            // symbol: "none", //去除点
            name: item.name,
            color: item.color1, // 折现颜色
            areaStyle: {
                //右，下，左，上
                color: new graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: item.color1,
                    },
                    {
                      offset: 1,
                      color: item.color2,
                    },
                  ],
                  false
                ),
            },
            // markPoint: {
            //   data: [
            //     {
            //       name: "最大值",
            //       type: "max",
            //       valueDim: "y",
            //       symbol: "rect",
            //       symbolSize: [60, 26],
            //       symbolOffset: [0, -20],
            //       itemStyle: {
            //         color: "rgba(0,0,0,0)",
            //       },
            //       label: {
            //         color: "#FC9010",
            //         backgroundColor: "rgba(252,144,16,0.1)",
            //         borderRadius: 6,
            //         padding: [7, 14],
            //         borderWidth: 0.5,
            //         borderColor: "rgba(252,144,16,.5)",
            //         formatter: item.name+"：{c}",
            //       },
            //     },
            //     {
            //       name: "最大值",
            //       type: "max",
            //       valueDim: "y",
            //       symbol: "circle",
            //       symbolSize: 6,
            //       itemStyle: {
            //         color: "#FC9010",
            //         shadowColor: "#FC9010",
            //         shadowBlur: 8,
            //       },
            //       label: {
            //         formatter: "",
            //       },
            //     },
            //   ],
            // },
          }))
      };
    },
  },
};
</script>
<style lang='scss' scoped>
.right_top_inner {
  margin-top: 10px;
}
</style>